import { render } from "./PasswordCodePage.vue?vue&type=template&id=8de9dde2&ts=true"
import script from "./PasswordCodePage.vue?vue&type=script&lang=ts"
export * from "./PasswordCodePage.vue?vue&type=script&lang=ts"

import "./PasswordCodePage.vue?vue&type=style&index=0&id=8de9dde2&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__